/**
 * A suggestion list under an input (Companies House names, dialling codes).
 * Fixed-position in the input's own shadow root; rows are picked on
 * mousedown so the input's blur doesn't close the list first.
 */
export function suggestionList(input: HTMLInputElement, minWidth = 0) {
  let list: HTMLDivElement | null = null;
  const root = input.getRootNode() as ShadowRoot;
  function close() {
    if (list) { list.remove(); list = null; }
  }
  function show<T>(items: T[], name: (item: T) => string, meta: (item: T) => string, onPick: (item: T) => void) {
    close();
    if (items.length === 0) return;
    list = document.createElement('div');
    list.className = 'ac-list';
    for (const item of items) {
      const row = document.createElement('div');
      row.className = 'ac-row';
      const nameEl = document.createElement('span');
      nameEl.className = 'ac-name';
      nameEl.textContent = name(item);
      const metaEl = document.createElement('span');
      metaEl.className = 'ac-meta';
      metaEl.textContent = meta(item);
      row.append(nameEl, metaEl);
      row.addEventListener('mousedown', (e) => {
        e.preventDefault();
        close();
        onPick(item);
      });
      list.appendChild(row);
    }
    root.appendChild(list);
    const rect = input.getBoundingClientRect();
    list.style.left = `${rect.left}px`;
    list.style.top = `${rect.bottom}px`;
    list.style.width = minWidth ? `max(${rect.width}px, ${minWidth}px)` : `${rect.width}px`;
  }
  input.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  window.addEventListener('scroll', close, { passive: true });
  return { show, close };
}
